import React, { useCallback, useEffect, useState } from 'react';
import { DebugContext } from 'App';
import { isMobile } from 'react-device-detect';
import {
	NavigationWrapper,
	SessionWrapper,
	TargetsAllianzUtilsWrapper,
	UiWrapper,
} from '@coinscrap/webapp-core';
import { MainModal } from 'components/MainModal/MainModal';
import { useGetError } from 'hooks/useGetError';

export const usePreemission = (
	targetStatus,
	simulationStep,
	targetId,
	trigger,
	setTrigger,
	customOnError = undefined,
	agent,
) => {
	const { openModal } = UiWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const { clearSession } = SessionWrapper.use();
	const isDebug = React.useContext(DebugContext);
	const { preemite } = TargetsAllianzUtilsWrapper.use();
	const getError = useGetError();

	const onError = useCallback(
		(e) => {
			openModal(() => <MainModal type="error" text={getError(e)} />, {
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-usePreemission-KO',
			});
		},
		[getError, openModal],
	);

	const [startProcess, setStartProcess] = useState(false);

	useEffect(() => {
		if (
			simulationStep === 2 &&
			(targetStatus === 'PENDING' || targetStatus === 'ACTIVATION_FAILED')
		) {
			setStartProcess(true);
		}
		return () => {};
	}, [simulationStep, targetStatus]);

	const getPreemission = useCallback(async () => {
		try {
			let preemission;
			try {
				preemission = await preemite(targetId);
			} catch (e) {
				console.log('❌ ERROR', e);
				if (customOnError) {
					customOnError(
						e,
						setTrigger,
						openModal,
						navigateTo,
						isDebug,
						clearSession,
						agent,
					);
				} else {
					onError(e);
				}
				return;
			}

			console.log('✅ preemite', preemission);

			if (preemission?.operationData?.allianzOperationId) {
				// PACKAGES
			} else {
			}
		} catch (e) {
			if (customOnError) {
				customOnError(e, setTrigger, openModal, navigateTo, isDebug, clearSession);
			} else {
				onError(e);
			}
		} finally {
		}
	}, [
		clearSession,
		customOnError,
		isDebug,
		navigateTo,
		onError,
		openModal,
		preemite,
		setTrigger,
		targetId,
	]);

	useEffect(() => {
		if (startProcess) {
			getPreemission();
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [startProcess, trigger]);

	return {};
};
